<script lang="ts" setup>
import { TextStyle, TextStyleShade } from '@app/customer/Components';

defineProps<{
  name?: string;
  value?: string;
}>();
</script>

<template>
  <TextStyle
    :shade="TextStyleShade.Subdued"
  >
    <template v-if="!$slots['default']">
      <span class="font-semibold mr-1">{{ name }}:</span>
      <span>{{ value }}</span>
    </template>
    <slot v-else />
  </TextStyle>
</template>
